import SecondaryNavigation from "@/components/navigation/SecondaryNavigation";
import { secondaryNavigationData } from "@/components/navigation/navigationData";
import { useState } from "react";
import PasswordUpdateForm from "@/components/settings/PasswordUpdateForm";
import MfaSection from "@/components/settings/MfaSection";
import { filterNavItemsByRole } from "@/components/utils/adminUtils";

// Helper to set current section and filter by user role
const getNavWithCurrent = (currentName: string, userRole?: string) => {
  // First filter by role, then mark current section
  const filteredNav = filterNavItemsByRole(secondaryNavigationData, userRole);
  return filteredNav.map((item) => ({
    ...item,
    current: item.name === currentName,
  }));
};

// Simple tab list component
import Tabs from "@/components/common/Tabs";

export default function SecuritySettings() {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = ["Security Settings", "Permission Management"];
  return (
    <main className="bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 min-h-screen">
      <div className="mx-auto max-w-7xl lg:flex lg:gap-x-16 lg:px-8">
        <SecondaryNavigation items={getNavWithCurrent("Security")} />
        <div className="flex flex-col w-full">
          <Tabs tabs={tabs} activeTab={activeTab} onTabClick={setActiveTab} />
          <div className="px-4 py-8 sm:px-6 lg:px-0 w-full">
            {activeTab === 0 && (
              <>
                <h2 className="text-xl font-semibold">Security Settings</h2>
                <p className="mt-2 text-gray-500 dark:text-gray-400">
                  Manage your password, 2FA, and security preferences here.
                </p>

                {/* Update Password Section */}
                <section className="mt-10 bg-white dark:bg-gray-800 rounded-lg shadow p-6 w-full">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">
                    Update Password
                  </h3>
                  <PasswordUpdateForm />
                </section>

                <MfaSection />

                {/* Delete Account Section */}
                <section className="mt-10 bg-white dark:bg-gray-800 rounded-lg shadow p-6 w-full border border-pink-200 dark:border-pink-400/40">
                  <h3 className="text-lg font-medium text-pink-700 dark:text-pink-300">
                    Delete Account
                  </h3>
                  <p className="mt-2 text-sm text-pink-600 dark:text-pink-300">
                    Warning: This action is irreversible. All your data will be
                    permanently deleted.
                  </p>
                  <form
                    className="mt-4 flex flex-col gap-4"
                    onSubmit={(e) => {
                      e.preventDefault(); /* handleDeleteAccount */
                    }}
                  >
                    <label
                      htmlFor="confirm-delete"
                      className="block text-sm font-medium text-gray-700 dark:text-gray-300"
                    >
                      Type <span className="font-bold">DELETE</span> to confirm:
                    </label>
                    <input
                      id="confirm-delete"
                      name="confirmDelete"
                      type="text"
                      autoComplete="off"
                      required
                      className="mt-1 block w-full bg-white dark:bg-gray-600 rounded-md border-gray-300 dark:border-gray-600 shadow-sm focus:border-pink-500 focus:ring-pink-500 sm:text-sm"
                    />
                    <button
                      type="submit"
                      className="inline-flex items-center rounded-md bg-pink-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                    >
                      Delete Account
                    </button>
                  </form>
                </section>
              </>
            )}
            {activeTab === 1 && (
              <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 border border-gray-200 dark:border-gray-700 w-full">
                <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">
                  Permission Management
                </h3>
                <p className="text-sm text-gray-500 mb-4">
                  Manage permissions for roles and users.{" "}
                  {/* TODO: Fetch and display permissions from the API here. */}
                </p>
                {/* Placeholder for permissions table/list */}
                <div className="bg-gray-50 dark:bg-gray-900 border border-dashed border-gray-300 dark:border-gray-600 rounded p-6 text-center text-gray-400">
                  Permission management UI coming soon.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
